import React from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "./ScrollAnimation";
import "./ProductsPreview.css";

const ProductsPreview = () => {
  const categories = [
    {
      id: 1,
      name: "Kompresör",
      description:
        "Tüm marka ve modellerde kompresörlerin bakım, onarım ve satış hizmetlerini uzman ekibimizle gerçekleştiriyoruz. Pistonlu ve Vidalı kompresörlerde profesyonel hizmet sunuyoruz.",
      icon: "🔧",
      features: [
        "Bakım & Onarım",
        "Yedek Parça",
        "Kurulum",
        "Arıza Teşhisi",
        "Periyodik Bakım",
      ],
    },
    {
      id: 2,
      name: "Jeneratör",
      description:
        "Dizel ve benzinli jeneratörlerin profesyonel bakım ve onarım hizmetlerini deneyimli teknisyenlerimizle sunuyoruz. Acil durum güç sistemlerinde güvenilir çözümler.",
      icon: "⚡",
      features: [
        "Motor Revizyon",
        "Alternatör Tamiri",
        "Kontrol Panosu",
        "Yakıt Sistemi",
        "Elektrik Bağlantıları",
      ],
    },
    {
      id: 3,
      name: "Blower",
      description:
        "Endüstriyel blower ve fan sistemlerinin bakım, onarım ve performans optimizasyonu hizmetlerini veriyoruz. Hava akış sistemlerinde uzman çözümler.",
      icon: "🌀",
      features: [
        "Fan Bakımı",
        "Motor Yatak",
        "Vibrasyon Analizi",
        "Hava Akış Optimizasyonu",
        "Performans Testi",
      ],
    },
  ];

  return (
    <section className="products-preview section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Hizmet Kategorilerimiz</h2>
          <p className="section-subtitle">
            Kompresör, Jeneratör ve Blower sistemlerinde uzman hizmetlerimizi
            keşfedin
          </p>
        </div>

        <div className="products-grid">
          {categories.map((category, index) => (
            <ScrollAnimation
              key={category.id}
              direction="right"
              delay={index * 150}
            >
              <div className="product-card">
                <div className="product-image">
                  <span className="product-icon">{category.icon}</span>
                </div>
                <div className="product-content">
                  <h3 className="product-title">{category.name}</h3>
                  <p className="product-description">{category.description}</p>
                  <ul className="product-features">
                    {category.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>{feature}</li>
                    ))}
                  </ul>
                  <Link to="/hizmetler" className="product-link">
                    Detayları Görüntüle →
                  </Link>
                </div>
              </div>
            </ScrollAnimation>
          ))}
        </div>

        <div className="preview-cta">
          <Link to="/hizmetler" className="btn">
            Tüm Hizmetleri Görüntüle
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsPreview;
